import vSelect from 'vue-select';

// Custom icons (requires global `feather-icon` component)
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'XIcon',
          svgClasses: 'w-4 h-4',
        },
      }),
  },
  OpenIndicator: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'ChevronDownIcon',
          svgClasses: 'w-5 h-5',
        },
      }),
  },
});

// Patch for Vue3-compat: $refs with refInFor may not be an Array,
// and vue-select's dist bundle spreads it, throwing:
// "Invalid attempt to spread non-iterable instance"
const normalizeRefArray = (ref) => {
  if (!ref) return [];
  return Array.isArray(ref) ? ref : [ref];
};

if (
  vSelect &&
  vSelect.methods &&
  typeof vSelect.methods.toggleDropdown === 'function' &&
  !vSelect.methods.__safeToggleDropdownPatched
) {
  const originalToggle = vSelect.methods.toggleDropdown;

  vSelect.methods.toggleDropdown = function (e) {
    const targetIsNotSearch = e && e.target !== this.searchEl;
    if (targetIsNotSearch && e && typeof e.preventDefault === 'function')
      e.preventDefault();

    const deselectButtons = normalizeRefArray(
      this.$refs && this.$refs.deselectButtons,
    );
    const clearButtons = normalizeRefArray(
      this.$refs && this.$refs.clearButton,
    );
    const ignoreTargets = deselectButtons.concat(clearButtons).filter(Boolean);

    if (
      this.searchEl === undefined ||
      ignoreTargets.some((el) =>
        el && el.contains ? el.contains(e.target) : el === e.target,
      )
    ) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      return;
    }

    if (this.open && targetIsNotSearch) {
      this.searchEl && this.searchEl.blur && this.searchEl.blur();
      return;
    }

    if (this.disabled) return;
    this.open = true;
    this.searchEl && this.searchEl.focus && this.searchEl.focus();
  };

  vSelect.methods.__originalToggleDropdown = originalToggle;
  vSelect.methods.__safeToggleDropdownPatched = true;
}

const VSelectCustom = {
  name: 'v-select',
  inheritAttrs: false,
  model: { prop: 'value', event: 'input' },
  props: {
    value: { required: false },
    options: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: false },
  },
  methods: {
    toArray(value) {
      if (Array.isArray(value)) return value;
      if (value === null || value === undefined || value === '') return [];
      return [value];
    },
  },
  render(createElement) {
    const normalizedOptions = Array.isArray(this.options) ? this.options : [];
    const normalizedValue = this.multiple
      ? this.toArray(this.value)
      : this.value;

    return createElement(vSelect, {
      attrs: this.$attrs,
      props: {
        ...this.$props,
        options: normalizedOptions,
        value: normalizedValue,
        multiple: this.multiple,
      },
      on: {
        ...this.$listeners,
        input: (val) => {
          const out = this.multiple ? this.toArray(val) : val;
          this.$emit('input', out);
        },
      },
    });
  },
};

export default VSelectCustom;
